export class CreateDataCatalogPipelineRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "definition",
            "baseName": "definition",
            "type": "DataCatalogPipelineDefinition",
            "format": ""
        },
        {
            "name": "schedule",
            "baseName": "schedule",
            "type": "DataCatalogPipelineSchedule",
            "format": ""
        },
        {
            "name": "agentSessionId",
            "baseName": "agentSessionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "viewDatasetId",
            "baseName": "viewDatasetId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateDataCatalogPipelineRequest.attributeTypeMap;
    }
    constructor() {
    }
}
